import CreateTripGroupContainer from './CreateTripGroupContainer';
import CreateTripGroupHelp from './CreateTripGroupHelp';

export { CreateTripGroupHelp };
export default CreateTripGroupContainer;
